
export default {
    namespaced: true, 

    state: {
        patientId: null,
        facilityId: null,
        patientTitle: null,
        patientName: null,
        patientPhone: null,
        patientAddress: {},
        deviceId: null,
        dueDate: null,
        eddDate: null,
        testDatesResponse: [],
        reason: 0,
        method: null,
        note: null,
        collectionPoint: null,
        deliveryAddress: {},
        shippingAddressType: null,
        language: null,
        testReasons: [],
        ccEmails: [],
        orderingOnBehalfOfOtherHcp: "0",
        orderingOnBehalfOfOtherHcpData: {}
    }, 

    getters: {
        GetPatientId(state) {
            return state.patientId
        },

        GetFacilityId(state) {
            return state.facilityId
        },

        GetPatientName(state) {
            return state.patientName
        },

        GetPatientTitle(state) {
            return state.patientTitle
        },

        GetPatientPhone(state) {
            return state.patientPhone
        },

        GetPatientAddress(state) {
            return state.patientAddress
        },

        GetPatientLat(state) {
            return state.patientLat
        },

        GetPatientLong(state) {
            return state.patientLong
        },

        GetDeviceId(state) {
            return state.deviceId
        },

        GetEddDate(state) {
            return state.eddDate
        },

        GetTestDatesResponse(state) {
            return state.testDatesResponse
        },

        GetDueDate(state) {
            return state.dueDate
        },

        GetReason(state) {
            return state.reason
        },

        GetMethod(state) {
            return state.method
        },

        GetNote(state) {
            return state.note
        },

        GetCollectionPoint(state) {
            return state.collectionPoint
        },

        GetDeliveryAddress(state) {
            return state.deliveryAddress
        },

        GetShippingAddressType(state) {
            return state.shippingAddressType
        },

        GetTestReasons(state) {
            return state.testReasons
        },

        GetTestTeamsCCEmails(state) {
            return state.ccEmails
        },

        GetLanguage(state) {
            return state.language
        },

        GetOrderingOnBehalfOfOtherHcp(state) {
            return state.orderingOnBehalfOfOtherHcp
        },

        GetOrderingOnBehalfOfOtherHcpData(state) {
            return state.orderingOnBehalfOfOtherHcpData
        }
    },

    mutations: {
        PUSH_CREATED_PATIENT(state, data) {
            state.createdPatient = data
        },

        SET_PATIENT_DETAILS(state, data) {
            state.patientId = data.id
            state.patientTitle = data.title
            state.patientName = `${data.firstName} ${data.surname}`
            state.patientPhone = data.phone
            state.language = data.preferredLanguage
            state.patientAddress = data.address
        },

        SET_DEVICE_ID(state, data) {
            state.deviceId = data
        },

        SET_FACILITY_ID(state, data) {
            state.facilityId = data
        },

        SET_EDD_DATE(state, data) {
            state.eddDate = data
        },

        SET_TEST_DATES_RESPONSE(state, data) {
            state.testDatesResponse = data
        },

        SET_TEST_DUE_DATE(state, data) {
            state.dueDate = data
        },

        SET_REASON(state, data) {
            state.reason = data
        },

        SET_NOTE(state, data) {
            state.note = data
        },

        SET_DELIVERY_METHOD(state, data) {
            state.collectionPoint = null
            state.shippingAddressType = null
            state.deliveryAddress = {}
            state.method = data
        },

        SET_DELIVERY_ADDRESS(state, data) {
            if(data == null) {
                state.deliveryAddress = {}
            } else {
                state.deliveryAddress = data
            }
        },

        SET_COLLECTION_POINT(state, data) {
            state.collectionPoint = data
        },

        SET_SHIPPING_ADDRESS_TYPE(state, data) {
            state.shippingAddressType = data
        },

        SET_LANGUAGE(state, data) {
            state.language = data
        },

        SET_TEST_REASON(state, data) {
            if(state.testReasons.includes(data)) {
                state.testReasons = state.testReasons.filter(x => x !== data)
            } else {
                state.testReasons.push(data)
            }
        },

        SET_TEST_TEAM_CC_EMAIL(state, data) {
            if(state.ccEmails.includes(data)) {
                state.ccEmails = state.ccEmails.filter(x => x !== data)
            } else {
                state.ccEmails.push(data)
            }
        },

        SET_ORDERING_ON_BEHALF_OF_OTHER_HCP(state, data) {
            state.orderingOnBehalfOfOtherHcp = data
        },

        SET_ORDERING_ON_BEHALF_OF_OTHER_HCP_DATA(state, data) {
            state.orderingOnBehalfOfOtherHcpData = data
        },

        CLEAR_TEST_REASONS(state) {
            state.testReasons = []
        },

        CLEAR_DATA(state) {
            state.patientId = null
            state.facilityId = null
            state.patientName = null
            state.patientPhone = null
            state.patientAddress = {}
            state.language = null
            state.deviceId = null
            state.eddDate = null
            state.dueDate = null
            state.reason = 0
            state.method = null
            state.note = null
            state.collectionPoint = null
            state.deliveryAddress = {}
            state.shippingAddressType = null
            state.alternativeLanguage = null
            state.testDatesResponse = []
            state.testReasons = []
            state.orderingOnBehalfOfOtherHcp = "0"
            state.orderingOnBehalfOfOtherHcpData = {}
            state.ccEmails = []
        }
    },

    actions: {
        SetPatientDetails({commit}, data) {
            commit('SET_PATIENT_DETAILS', data)
        },

        SetDeviceId({commit}, data) {
            commit('SET_DEVICE_ID', data)
        },

        SetFacilityId({commit}, data) {
            commit('SET_FACILITY_ID', data)
        },

        SetEddDate({commit}, data) {
            commit('SET_EDD_DATE', data)
        },

        SetTestDatesResponse({commit}, data) {
            commit('SET_TEST_DATES_RESPONSE', data)
        },

        SetDueDate({commit}, data) {
            commit('SET_TEST_DUE_DATE', data)
        },

        SetReason({commit}, data) {
            commit('SET_REASON', data)
        },

        SetNote({commit}, data) {
            commit('SET_NOTE', data)
        },

        SetDeliveryMethod({commit}, data) {
            commit('SET_DELIVERY_METHOD', data)
        },

        SetDeliveryAddress({commit}, data) {
            commit('SET_DELIVERY_ADDRESS', data)
        },

        SetCollectionPoint({commit}, data) {
            commit('SET_COLLECTION_POINT', data)
        },

        SetShippingAddressType({commit}, data) {
            commit('SET_SHIPPING_ADDRESS_TYPE', data)
        },

        SetAlternativeLanguage({commit}, data) {
            commit('SET_ALTERNATIVE_LANGUAGE', data)
        },

        SetLanguage({commit}, data) {
            commit('SET_LANGUAGE', data)
        },

        SetTestReason({commit}, data) {
            commit('SET_TEST_REASON', data)
        },

        SetTestTeamCCEmail({commit}, data) {
            commit('SET_TEST_TEAM_CC_EMAIL', data)
        },

        SetOrderingOnBehalfOfOtherHcp({commit}, data) {
            commit('SET_ORDERING_ON_BEHALF_OF_OTHER_HCP', data)
        },

        SetOrderingOnBehalfOfOtherHcpData({commit}, data) {
            commit('SET_ORDERING_ON_BEHALF_OF_OTHER_HCP_DATA', data)
        },

        ClearTestReasons({commit}) {
            commit('CLEAR_TEST_REASONS')
        },
 
        ClearCreatedPatient({commit}) {
            commit('CLEAR_CREATED_PATIENT')
        },

        ClearData({commit}) {
            commit('CLEAR_DATA')
        }
    }
}